import React from 'react'
//
import { Markdown, Html } from '~storybook/blocks'

const FormattedText = ({ text, format = 'html' }) => {
  return format === 'markdown' ? <Markdown text={text} /> : <Html value={text} />
}

export default FormattedText
